import { extInfo } from 'lib/extInfo';
import { stringify } from 'qs';

export const SEARCH_PER_PAGE_LIMIT = 500;

export const getExtsBySearchType = (searchType: string) => {
    return extInfo.getExtsByKind(searchType).join(',');
};

export const getSearchQueryString = (query: string, searchType?: string) => stringify({ query, searchType }, { addQueryPrefix: true});
